import Intro from "../sections/Intro/Intro";
import Footer from "../components/Footer/Footer";
import Reviews from "../sections/Reviews/Reviews";
import Offerings from "../sections/Offerings/Offerings";
import Header from "../components/Header/Header";

const Home = () => {
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Gain and maintain financial clarity."
        secondary="Exceptional bookkeeping and advisory for businesses that take their finances seriously."
      />
      <Reviews />
      <img
        className="crystals_light crystals_flipped"
        src={require("../images/crystals_light.png")}
        alt="crystals"
      />
      <Offerings />
      <Footer />
    </div>
  );
};

export default Home;
